export default __webpack_public_path__ + "static/media/Charles-de-Montebello.3cee5ff8.jpg";